import { useEffect } from 'react'

import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Input } from '@fortem-monorepo/react-ui'

import { FormFieldRow } from '@/components/forms/BookTradeForm/FormFieldRow'
import { AdministratorFormField } from '@/pages/instruments/new-instrument/form-fields/AdministratorFormField'
import { BbgTickerFormField } from '@/pages/instruments/new-instrument/form-fields/BbgTickerFormField'
import { CountryIdFormField } from '@/pages/instruments/new-instrument/form-fields/CountryIdFormField'
import { CurrencyIdField } from '@/pages/instruments/new-instrument/form-fields/CurrencyIdField'
import { CurrencyIdInput } from '@/pages/instruments/new-instrument/form-fields/CurrencyIdInput'
import { DistributionPolicyFormField } from '@/pages/instruments/new-instrument/form-fields/DistributionPolicyFormField'
import { FundLeiFormField } from '@/pages/instruments/new-instrument/form-fields/FundLeiFormField'
import { ISINField } from '@/pages/instruments/new-instrument/form-fields/ISINField'
import { IssuerNameFormField } from '@/pages/instruments/new-instrument/form-fields/IssuerNameFormField'
import { LaunchDateFormField } from '@/pages/instruments/new-instrument/form-fields/LaunchDateFormField'
import { LongNameFormField } from '@/pages/instruments/new-instrument/form-fields/LongNameFormField'
import { QuoteFactorFormField } from '@/pages/instruments/new-instrument/form-fields/QuoteFactorFormField'
import { SedolField } from '@/pages/instruments/new-instrument/form-fields/SedolField'
import { ShareclassNameFormField } from '@/pages/instruments/new-instrument/form-fields/ShareclassNameFormField'
import { UnitMultiplierFormField } from '@/pages/instruments/new-instrument/form-fields/UnitMultiplierFormField'
import { FundSchemaType } from '@/pages/instruments/new-instrument/schemas/fund.schema'

export interface FundFormFieldsProps {}

export const FundFormFields: React.FC<FundFormFieldsProps> = ({}) => {
  const { control, trigger, register, setValue } = useFormContext<FundSchemaType>()

  useEffect(() => {
    trigger()
  }, [])

  return (
    <div className={'@container flex flex-col gap-6'}>
      <FormFieldRow>
        <ISINField />
        <BbgTickerFormField placeholder={'FCUSMEA ID Equity...'} />
        <CurrencyIdField />
        <FundLeiFormField />
      </FormFieldRow>
      <FormFieldRow>
        <LaunchDateFormField />
        <CountryIdFormField />
        <LongNameFormField placeholder={'Fortem Capital US Equity Income Fund'} />
        <ShareclassNameFormField placeholder={'M EUR ACC Hedged'} />
      </FormFieldRow>

      <FormFieldRow>
        <FormField
          name="hedge_currency_id"
          control={control}
          render={({ field: { value } }) => {
            return (
              <FormItem>
                <div className="flex items-center gap-2">
                  <FormLabel>Hedge Currency</FormLabel>
                  <FormError />
                </div>
                <CurrencyIdInput
                  showNone={'None'}
                  value={value?.toString()}
                  setValue={(value) =>
                    setValue('hedge_currency_id', value ? parseInt(value) : null, {
                      shouldValidate: true,
                    })
                  }
                  className={'min-w-auto'}
                  placeholder={'Select a hedge currency'}
                />
              </FormItem>
            )
          }}
        />
        <DistributionPolicyFormField />
        <IssuerNameFormField />
        <AdministratorFormField />
      </FormFieldRow>

      <FormFieldRow>
        <SedolField />
        <FormField
          name="morning_star_id"
          control={control}
          render={() => {
            return (
              <FormItem>
                <div className="flex items-center justify-between gap-2">
                  <FormLabel>Morningstar ID</FormLabel>
                  <FormError />
                </div>
                <Input {...register('morning_star_id')} placeholder={'Enter a morningstar id...'} />
              </FormItem>
            )
          }}
        />

        <FormField
          name="citi_id"
          control={control}
          render={() => {
            return (
              <FormItem>
                <div className="flex items-center justify-between gap-2">
                  <FormLabel>Citi ID</FormLabel>
                  <FormError />
                </div>
                <Input {...register('citi_id')} placeholder={'Enter a citi id...'} />
              </FormItem>
            )
          }}
        />

        <FormField
          name="lipper_id"
          control={control}
          render={() => {
            return (
              <FormItem>
                <div className="flex items-center justify-between gap-2">
                  <FormLabel>Lipper ID</FormLabel>
                  <FormError />
                </div>
                <Input {...register('lipper_id')} placeholder={'Enter a lipper id...'} />
              </FormItem>
            )
          }}
        />
      </FormFieldRow>

      <FormFieldRow>
        <FormField
          name="mex_id"
          control={control}
          render={() => {
            return (
              <FormItem>
                <div className="flex items-center justify-between gap-2">
                  <FormLabel>MEX ID</FormLabel>
                  <FormError />
                </div>
                <Input {...register('mex_id')} placeholder={'Enter a mex id...'} />
              </FormItem>
            )
          }}
        />

        <FormField
          name="valor_id"
          control={control}
          render={() => {
            return (
              <FormItem>
                <div className="flex items-center justify-between gap-2">
                  <FormLabel>Valor ID</FormLabel>
                  <FormError />
                </div>
                <Input {...register('valor_id')} placeholder={'Enter a valor id...'} />
              </FormItem>
            )
          }}
        />

        <UnitMultiplierFormField />
        <QuoteFactorFormField />
      </FormFieldRow>
    </div>
  )
}
